import React from 'react';

export default function ArticleAudioProgressBar({ currentTime, duration, audioRef }) {
  function handleClick(e) {
    const bounds = document.getElementById('outer-progress-bar').getBoundingClientRect();
    const width = bounds.right - bounds.left;
    const whereClicked = e.clientX - bounds.left;
    if (audioRef.current) {
      audioRef.current.currentTime = (whereClicked / width) * duration;
    }
  }

  const width = currentTime ? `${(currentTime / duration) * 100}%` : 0;
  return (
    <div id={'outer-progress-bar'} style={styles.totalTime} onClick={handleClick}>
      <div style={{ ...styles.passedTime, width }} />
    </div>
  );
}

const styles = {
  totalTime: {
    width: '100%',
    height: 8,
    backgroundColor: '#C5E3C1',
    marginBottom: 8
  },
  passedTime: {
    left: 0,
    height: '100%',
    backgroundColor: '#003B1B'
  }
};
